import { ReactNode } from "react";

export function DashboardSectionHeader({
  eyebrow,
  title,
  meta,
  children,
}: {
  eyebrow: string;
  title: string;
  meta: ReactNode;
  children: ReactNode;
}) {
  return (
    <header
      className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
      data-oid="m7mqx3g"
    >
      <div className="max-w-2xl" style={{ display: "flex", flexDirection: "column" }} data-oid="xxb.ahx">
        <div
          className="dashboard-section-eyebrow typography-overline inline-flex items-center gap-1.5 uppercase"
          style={{ letterSpacing: "0.2em", marginBottom: "clamp(8px, 0.8vh, 10px)" }}
          data-oid="fth474t"
        >
          <span
            className="eyebrow-dot h-1.5 w-1.5 rounded-full bg-sky-500"
            data-oid="pg0uf3h"
          />
          {eyebrow}
        </div>
        <h2
          className="dashboard-section-title typography-page-title text-[1.15rem] font-semibold tracking-tight text-white sm:text-[1.3rem] lg:text-[1.5rem]"
          data-oid="df49:lw"
        >
          {title}
        </h2>
        <p
          className="dashboard-section-meta typography-subtitle text-[9px] font-medium text-slate-500 sm:text-[10px]"
          style={{ marginTop: "clamp(4px, 0.42vh, 6px)" }}
          data-oid="gc5lwn6"
        >
          {meta}
        </p>
      </div>
      {children}
    </header>
  );
}
